var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatstableguy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_992",
    "data-name": "Group 992",
    xmlns: "http://www.w3.org/2000/svg",
    width: 424.604,
    height: 391.236,
    viewBox: "0 0 424.604 391.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(192.444 116.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(0 67.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 106.288,
    height: 4.996,
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(41.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M405.025,366.732l19.937-72.193H341.971l-18.054,72.193Z",
    transform: "translate(-323.917 -294.539)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(46.626 3.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M326.537,359.866h74.14l17.257-63.392H343.412Z",
    transform: "translate(-326.537 -296.474)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(62.246 3.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M401.072,301.031H326.537l1.254-4.557h74.523Z",
    transform: "translate(-326.537 -296.474)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(127.105 4.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M333.374,298.126a.815.815,0,1,1-.813-.786A.8.8,0,0,1,333.374,298.126Z",
    transform: "translate(-331.745 -297.34)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(2.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M331.8,298.126a.815.815,0,1,1-.813-.786A.8.8,0,0,1,331.8,298.126Z",
    transform: "translate(-330.173 -297.34)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(5.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M330.23,298.126a.815.815,0,1,1-.813-.786A.8.8,0,0,1,330.23,298.126Z",
    transform: "translate(-328.601 -297.34)",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(67.596 19.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(0 4.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M364.421,320.062l-8.161,9.023a11.05,11.05,0,0,1-5.012-9.073c.027-6.31,5.994-11.48,13.221-11.452s13.152,5.242,13.127,11.552Z",
    transform: "translate(-351.248 -308.56)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(5.566 17.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M359.273,316.155a18.414,18.414,0,0,0-2.328,2.258c-1.457,1.51-3.541,3.716-6.035,6.41l-.282.305.35.255a14.536,14.536,0,0,0,13.762,1.3,13.375,13.375,0,0,0,5.66-4.4,10.959,10.959,0,0,0,2.1-5.922l.016-.4-.407,0c-3.906-.019-7.14,0-9.381.031a20.877,20.877,0,0,0-3.455.16,25.16,25.16,0,0,0,3.593.269c2.249.1,5.428.214,9.231.31l-.392-.4a10.382,10.382,0,0,1-2.033,5.459,12.7,12.7,0,0,1-5.3,4.075,13.929,13.929,0,0,1-12.936-1.1l.07.558c2.363-2.673,4.313-4.928,5.674-6.533A21.85,21.85,0,0,0,359.273,316.155Z",
    transform: "translate(-350.629 -315.955)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(18.064 8.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M356.541,311.584a.739.739,0,1,1-.737-.717A.726.726,0,0,1,356.541,311.584Z",
    transform: "translate(-355.064 -310.867)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(18.794 3.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M362.262,308.488c0-.248-3.947-.464-8.817-.483h-1.37l-.132.129c-3.047,2.963-5.267,5.357-5.1,5.517s2.66-1.965,5.749-4.887l-.325.129,1.176.009C358.311,308.922,362.262,308.736,362.262,308.488Z",
    transform: "translate(-346.833 -308.005)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(31.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M354.775,319.076a25.875,25.875,0,0,0,.844-3.327c.5-2.189,1.208-5.388,2.019-9.306l.089-.429-.46,0-18.446-.153c.1-.081-.869.691-.46.367v0l0,.007,0,.012-.005.028-.011.053-.021.107-.041.212-.084.426-.164.845q-.166.843-.326,1.672-.321,1.657-.63,3.256c-.407,2.124-.794,4.161-1.161,6.085l-.093.484.5,0c5.54-.014,10.2-.078,13.441-.141l3.741-.1a5.521,5.521,0,0,0,1.268-.1,8.744,8.744,0,0,0-1.429-.109l-3.824-.126c-3.257-.088-7.818-.188-13.193-.243l.412.483c.387-1.92.8-3.952,1.224-6.072q.318-1.6.648-3.254c.109-.552.218-1.11.328-1.67l.168-.845.084-.426.041-.212.021-.107.011-.053,0-.028,0-.012,0-.007v0c.41-.327-.557.441-.457.364l18.446-.014-.369-.433c-.7,3.787-1.238,6.938-1.605,9.173A32.948,32.948,0,0,0,354.775,319.076Z",
    transform: "translate(-335.821 -305.852)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(19.161 22.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M355.926,319.911a.739.739,0,1,1-.737-.717A.727.727,0,0,1,355.926,319.911Z",
    transform: "translate(-354.449 -319.194)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(0.738 0.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M360.751,319.837c0-.248-3-.46-6.7-.474s-6.7.174-6.7.422,3,.46,6.7.474S360.751,320.086,360.751,319.837Z",
    transform: "translate(-347.351 -319.362)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(31.266 19.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M355.452,327.068a14.994,14.994,0,0,0,.81-2.382c.487-1.589,1.184-3.935,2-6.862l.116-.414-.453-.007c-5.021-.09-11.705-.157-19.02-.185.4-.3-.551.41-.453.338v0l0,.005,0,.009,0,.019-.011.04-.021.076-.041.155-.08.307-.162.614L337.811,320c-.212.8-.421,1.6-.626,2.379-.407,1.558-.8,3.068-1.177,4.514l-.137.527.558,0c5.642-.009,10.449-.072,13.806-.138l3.89-.1a5.6,5.6,0,0,0,1.327-.107,8.441,8.441,0,0,0-1.491-.119l-3.972-.133c-3.375-.091-8.077-.191-13.558-.243l.421.526c.391-1.443.8-2.948,1.218-4.5q.313-1.171.637-2.375l.325-1.213.162-.612.082-.309.041-.153.02-.078.011-.038.005-.019,0-.01,0-.005v0c.1-.074-.854.638-.449.336,7.315.028,14,.012,19.022-.04l-.337-.421c-.7,2.818-1.247,5.137-1.616,6.774A19.866,19.866,0,0,0,355.452,327.068Z",
    transform: "translate(-335.87 -317.144)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(36.832 3.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M350.916,308.613c0-.248-2.824-.458-6.307-.472s-6.311.177-6.313.424,2.824.46,6.309.474S350.916,308.861,350.916,308.613Z",
    transform: "translate(-338.296 -308.14)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(36.601 5.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M351.078,309.771c0-.246-2.84-.458-6.345-.472s-6.348.176-6.35.424,2.84.46,6.347.474S351.076,310.019,351.078,309.771Z",
    transform: "translate(-338.383 -309.298)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(36.667 7.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M350.847,310.888c0-.248-2.742-.46-6.124-.472s-6.127.178-6.129.426,2.742.458,6.125.472S350.845,311.136,350.847,310.888Z",
    transform: "translate(-338.594 -310.415)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(37.049 23.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M350.535,319.743c0-.248-2.692-.46-6.013-.472s-6.017.178-6.017.426,2.69.458,6.013.472S350.533,319.991,350.535,319.743Z",
    transform: "translate(-338.505 -319.27)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(38.073 25.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M349.182,321.022c0-.248-2.294-.459-5.127-.469s-5.132.181-5.132.429,2.294.458,5.128.469S349.182,321.27,349.182,321.022Z",
    transform: "translate(-338.924 -320.553)",
    fill: "#263238"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(0 188.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M698.367,336.285v9.468h-6.416V537.442H678.785V345.753H608.912V537.442H595.746V345.753H292.628V537.4H279.462V345.753h-5.7v-9.468Z",
    transform: "translate(-273.763 -336.285)",
    fill: "#263238"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(122.012 259.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M450.922,377.87c0,.191-3.833.346-8.56.346s-8.562-.155-8.562-.346,3.833-.348,8.562-.348S450.922,377.679,450.922,377.87Z",
    transform: "translate(-433.8 -377.522)",
    fill: "#263238"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(263.366 261.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.464,
    cy: 0.22,
    rx: 0.464,
    ry: 0.22,
    fill: "#455a64"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(80.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(10.904 17.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M457.635,310.611l49.175-48.276,1.063-5.226c.205-.957.41-2.024.6-3.235a12.431,12.431,0,0,0-.077-4.254,18.8,18.8,0,0,0-1.516-5.059,1.658,1.658,0,0,1,1.868-2.508c1.368.577,3.748,4.375,4.261,9.589s5.118-1.7,6.841-4.2,7.417-9.958,8.6-10.047c1.741-.129,2.187,1.693.407,4.142-1.8,2.48-6.6,10.163-5.232,10.988l.052-.009a6.5,6.5,0,0,1,6.793,3.256c1.242,2.3,2.624,5.571,1.491,7.077a86.792,86.792,0,0,1-7.841,8.024l-1.646,1.369s-42.543,59.568-51.815,61.5c-5.767,1.2-94.922,8.349-94.922,8.349l-6.725-23.733Z",
    transform: "translate(-369.017 -237.392)",
    fill: "#b78876"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(154.224 21.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(0.463 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M377.682,252.984l-4.55,4.223a5.37,5.37,0,0,1-1.712,1.213,1.89,1.89,0,0,1-1.989-.31,1.725,1.725,0,0,1-.266-1.765,5.215,5.215,0,0,1,1.045-1.563q2.213-2.567,4.422-5.135",
    transform: "translate(-369.04 -249.647)",
    fill: "#b78876"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M375.091,249.649c-.1-.079-.953.738-2.255,2.122l-2.248,2.461a8.082,8.082,0,0,0-1.254,1.641,2.257,2.257,0,0,0,.125,2.441,2.281,2.281,0,0,0,2.488.552,5.023,5.023,0,0,0,1.782-1.212l2.381-2.344a10.429,10.429,0,0,0,2.03-2.324,10.714,10.714,0,0,0-2.485,1.867c-.815.712-1.65,1.443-2.517,2.2a4.412,4.412,0,0,1-1.488.979,1.385,1.385,0,0,1-1.464-.276,1.443,1.443,0,0,1-.03-1.506,8.009,8.009,0,0,1,1.09-1.491l2.1-2.584A10.345,10.345,0,0,0,375.091,249.649Z",
    transform: "translate(-369.036 -249.644)",
    fill: "#aa6550"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(150.996 18.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(0.463 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M379.492,251.2l-4.55,4.221a5.4,5.4,0,0,1-1.712,1.215,1.894,1.894,0,0,1-1.989-.312,1.722,1.722,0,0,1-.266-1.763A5.174,5.174,0,0,1,372.022,253q2.21-2.567,4.42-5.133",
    transform: "translate(-370.85 -247.865)",
    fill: "#b78876"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M376.9,247.867c-.1-.079-.953.736-2.253,2.12l-2.249,2.461a8.131,8.131,0,0,0-1.254,1.641,2.257,2.257,0,0,0,.125,2.441,2.281,2.281,0,0,0,2.488.552,5.023,5.023,0,0,0,1.782-1.212l2.381-2.344a10.493,10.493,0,0,0,2.03-2.322,10.612,10.612,0,0,0-2.485,1.865c-.815.712-1.65,1.444-2.517,2.2a4.427,4.427,0,0,1-1.488.981,1.392,1.392,0,0,1-1.464-.276,1.446,1.446,0,0,1-.03-1.508,8,8,0,0,1,1.09-1.489c.721-.889,1.416-1.748,2.1-2.584A10.354,10.354,0,0,0,376.9,247.867Z",
    transform: "translate(-370.846 -247.862)",
    fill: "#aa6550"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(147.453 15.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0.463 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M381.478,249.742q-2.274,2.11-4.549,4.221a5.429,5.429,0,0,1-1.714,1.215,1.894,1.894,0,0,1-1.989-.312,1.722,1.722,0,0,1-.266-1.763,5.2,5.2,0,0,1,1.047-1.565l4.42-5.135",
    transform: "translate(-372.836 -246.403)",
    fill: "#b78876"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M378.887,246.405c-.1-.079-.953.738-2.253,2.122l-2.249,2.461a8.084,8.084,0,0,0-1.254,1.641,2.257,2.257,0,0,0,.125,2.441,2.281,2.281,0,0,0,2.488.552,5.023,5.023,0,0,0,1.782-1.212l2.381-2.344a10.434,10.434,0,0,0,2.03-2.322,10.608,10.608,0,0,0-2.485,1.865q-1.22,1.068-2.517,2.2a4.438,4.438,0,0,1-1.486.981,1.4,1.4,0,0,1-1.466-.276,1.451,1.451,0,0,1-.03-1.508,8.082,8.082,0,0,1,1.09-1.489c.721-.889,1.418-1.748,2.1-2.584A10.3,10.3,0,0,0,378.887,246.405Z",
    transform: "translate(-372.832 -246.4)",
    fill: "#aa6550"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(144.152 19.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M382.083,255.586c.013-.141-1.127-.362-2.772.126l.524.433a7.27,7.27,0,0,0,.116-3.02,7.584,7.584,0,0,0-1.7-3.673c-.7-.791-1.293-1.1-1.366-1.019-.2.171,1.7,1.936,2.153,4.837a8.643,8.643,0,0,1,.027,2.723l-.1.689.621-.255C381.009,255.841,382.09,255.762,382.083,255.586Z",
    transform: "translate(-376.867 -248.419)",
    fill: "#aa6550"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(24.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(10.89 10.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M422.322,241.3l-.209,66.128,26.684,1.229,1.081-15.849s12.872,1.889,15.563-7.469c1.718-5.978,1.288-52.179,1.288-52.179Z",
    transform: "translate(-422.113 -233.161)",
    fill: "#b78876"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M479.917,244.037c-1.978,3.951-11.395,11.181-11.395,11.181l-4.254,11.016c-3.694-2.8-8.657-2.635-9.595,3.64-.68,4.533,5.155,5.45,5.155,5.45-3.4,5.585-5.7,10.1-10.646,15.415-5.351,5.748-8.35,6.328-14.154,6.422h-6.4s-13.1-10.575-10.508-38.429,28.5-19.727,34.687-26.686C462.88,220.713,486.517,230.846,479.917,244.037Z",
    transform: "translate(-417.781 -227.145)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(1.794 10.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M418.566,277.555a9.508,9.508,0,0,0,3.166-.14,16.692,16.692,0,0,0,7.647-3.8c2.8-2.327,5.268-5.878,7.727-9.877,2.494-3.935,5.218-8.529,9.807-11.588,4.641-3,10.1-3.613,14.782-4.538,4.73-.858,9.019-2.165,11.939-4.39a12.376,12.376,0,0,0,4.782-6.846,6.874,6.874,0,0,0,.13-3.058,10.181,10.181,0,0,1-.271,3.025,12.386,12.386,0,0,1-4.8,6.677c-2.886,2.16-7.123,3.428-11.842,4.266-4.674.91-10.178,1.5-14.927,4.566-4.684,3.128-7.412,7.774-9.891,11.716-2.444,4.008-4.863,7.536-7.608,9.856a16.84,16.84,0,0,1-7.5,3.856,13.411,13.411,0,0,1-2.321.266C418.85,277.539,418.566,277.555,418.566,277.555Z",
    transform: "translate(-418.566 -233.317)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(0.282 6.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M418.756,256.447s.478-.134,1.381-.4a21.172,21.172,0,0,1,4.015-.864,9.272,9.272,0,0,1,6.181,1.336,4.9,4.9,0,0,1,2.149,3.137,4.267,4.267,0,0,1-1.245,3.945,3.5,3.5,0,0,1-2.157.826,4.645,4.645,0,0,1-2.376-.627,7.1,7.1,0,0,1-3.227-3.98,9.656,9.656,0,0,1,2.854-10.463,10.45,10.45,0,0,1,5.756-2.48,18.519,18.519,0,0,1,6.632.843,48.4,48.4,0,0,0,6.866,1.594,28.9,28.9,0,0,0,7.28.017,24.658,24.658,0,0,0,7.019-1.881,8.321,8.321,0,0,0,4.806-4.893,6.253,6.253,0,0,0-1.632-6.247,5.857,5.857,0,0,0-6.27-.895,4.728,4.728,0,0,0-2.322,2.113,4.9,4.9,0,0,0-.492,2.966,6.723,6.723,0,0,0,3.123,4.726,10.278,10.278,0,0,0,5.271,1.417,16.043,16.043,0,0,0,5-.745,18.259,18.259,0,0,0,12.426-13.334c.159-.9.223-1.377.223-1.377s-.114.467-.3,1.362a18.937,18.937,0,0,1-1.386,3.74,18.248,18.248,0,0,1-3.767,5.092,17.886,17.886,0,0,1-7.278,4.276,15.834,15.834,0,0,1-4.916.708,10.01,10.01,0,0,1-5.11-1.389,6.428,6.428,0,0,1-2.966-4.516,4.4,4.4,0,0,1,2.636-4.74,5.5,5.5,0,0,1,5.879.841,5.918,5.918,0,0,1,1.527,5.9c-.6,2.124-2.512,3.708-4.615,4.669a24.354,24.354,0,0,1-6.907,1.844,28.534,28.534,0,0,1-7.183-.016,47.914,47.914,0,0,1-6.816-1.579,18.8,18.8,0,0,0-6.766-.843,10.769,10.769,0,0,0-5.949,2.573,9.951,9.951,0,0,0-2.916,10.8,7.376,7.376,0,0,0,3.375,4.126,4.966,4.966,0,0,0,2.529.653,3.786,3.786,0,0,0,2.322-.9,4.5,4.5,0,0,0,1.3-4.175,5.115,5.115,0,0,0-2.262-3.259,9.4,9.4,0,0,0-6.316-1.312,20.2,20.2,0,0,0-4.024.934C419.218,256.266,418.756,256.447,418.756,256.447Z",
    transform: "translate(-418.756 -231.18)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(33.14 346.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M453.312,454.844l8.723-10.813-20.858-15.916-12.932,15.691,1.227,1.067c5.5,4.7,28.323,23.526,33.091,25.334C467.881,472.223,453.312,454.844,453.312,454.844Z",
    transform: "translate(-428.244 -428.115)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(0 15.265)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M460.192,457.226s4.8,6.471,3.214,6.869-25.385-17.79-35.156-26.7l.4-.426,27.575,21.441S458.938,456.348,460.192,457.226Z",
    transform: "translate(-428.249 -436.971)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(0.084 15.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M428.271,436.819a2.274,2.274,0,0,0,.328.31l.979.846,3.66,3.053c3.109,2.558,7.453,6.035,12.337,9.771s9.383,7.027,12.67,9.366l3.914,2.742,1.077.727a2.5,2.5,0,0,0,.389.238,2.442,2.442,0,0,0-.35-.288l-1.042-.774-3.851-2.822c-3.252-2.384-7.726-5.7-12.608-9.434s-9.245-7.184-12.39-9.7l-3.725-2.977c-.378-.3-.714-.562-1.02-.8A2.419,2.419,0,0,0,428.271,436.819Z",
    transform: "translate(-428.271 -436.819)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(27.709 35.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M430.04,450.337a10.934,10.934,0,0,1,2.139-1.208,11.212,11.212,0,0,1,2.438-.414,3.685,3.685,0,0,0-2.549.122A3.552,3.552,0,0,0,430.04,450.337Z",
    transform: "translate(-430.035 -448.557)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(24.03 28.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M433.279,445.474a2.88,2.88,0,0,0,1.29-.271c.683-.229,1.213-.483,1.184-.564a2.884,2.884,0,0,0-1.29.271C433.781,445.141,433.251,445.393,433.279,445.474Z",
    transform: "translate(-433.278 -444.614)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(23.05 26.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M433.969,443.965c.005.086.508.124,1.122.088s1.108-.138,1.1-.224-.508-.124-1.122-.088S433.964,443.879,433.969,443.965Z",
    transform: "translate(-433.969 -443.727)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(23.534 24.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M433.734,442.293c-.057.067.382.5.978.965s1.126.79,1.181.722-.382-.5-.977-.965S433.79,442.225,433.734,442.293Z",
    transform: "translate(-433.729 -442.284)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(24.259 22.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M433.24,441.35c-.071.041.269.677.935,1.267a2.712,2.712,0,0,0,1.386.8c.045-.078-.539-.46-1.167-1.024S433.318,441.3,433.24,441.35Z",
    transform: "translate(-433.231 -441.347)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(26.09 27.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M430.743,444.592a4.867,4.867,0,0,0,1.347,1.017,10.1,10.1,0,0,0,1.675.784,5.077,5.077,0,0,0,1.081.3.952.952,0,0,0,.662-.15.633.633,0,0,0,.219-.672,3.173,3.173,0,0,0-3.6-1.627,3.107,3.107,0,0,0-1.145.531c-.234.181-.334.31-.319.322a4.9,4.9,0,0,1,1.513-.638,3.18,3.18,0,0,1,1.732.157,2.606,2.606,0,0,1,1.511,1.324c.089.315-.193.493-.54.45a5.23,5.23,0,0,1-1.008-.265,12.158,12.158,0,0,1-1.663-.707C431.287,444.942,430.775,444.552,430.743,444.592Z",
    transform: "translate(-430.656 -444.151)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(26 24.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M433.041,446.106c.007.029.476-.15.89-.779a2.668,2.668,0,0,0,.408-1.226,1.624,1.624,0,0,0-.576-1.512.688.688,0,0,0-.9.281,1.747,1.747,0,0,0-.246.753,4.783,4.783,0,0,0-.009,1.265,2.3,2.3,0,0,0,.339,1.11c.048-.014-.077-.436-.111-1.127a5.6,5.6,0,0,1,.073-1.2c.041-.415.318-1,.7-.8a1.452,1.452,0,0,1,.433,1.224,2.66,2.66,0,0,1-.31,1.131A5.766,5.766,0,0,1,433.041,446.106Z",
    transform: "translate(-432.57 -442.513)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(5.018 9.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M442.925,433.811c-.032.048.642.4,1.5,1.227a8.238,8.238,0,0,1,2.265,3.906,8.045,8.045,0,0,1-.246,4.473c-.389,1.107-.833,1.71-.781,1.741a1.522,1.522,0,0,0,.334-.407,6.806,6.806,0,0,0,.662-1.26,7.7,7.7,0,0,0,.346-4.618,7.9,7.9,0,0,0-2.422-3.994,6.926,6.926,0,0,0-1.168-.846A1.534,1.534,0,0,0,442.925,433.811Z",
    transform: "translate(-442.924 -433.809)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(7.154 3.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M447.152,429.9a90.309,90.309,0,0,0-6.884,8.2,90.175,90.175,0,0,0,6.884-8.2Z",
    transform: "translate(-440.266 -429.903)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(11.919 21.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M438.067,440.5a14.8,14.8,0,0,0,2.8,2.617,15.125,15.125,0,0,0,3.243,2.094c.05-.076-1.377-1.036-3.04-2.336S438.132,440.434,438.067,440.5Z",
    transform: "translate(-438.064 -440.495)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(7.42 18.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M444.084,438.683c-.091.01-.116.364-.225.77s-.25.734-.175.784.367-.236.489-.708S444.17,438.668,444.084,438.683Z",
    transform: "translate(-443.664 -438.683)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(7.715 15.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M443.715,436.926c-.089.009-.127.322-.084.7s.15.672.237.664.127-.322.084-.7S443.8,436.916,443.715,436.926Z",
    transform: "translate(-443.613 -436.926)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(6.301 12.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M444.084,435.467c-.043.079.237.29.458.627s.312.664.4.66.145-.415-.136-.829S444.112,435.39,444.084,435.467Z",
    transform: "translate(-444.079 -435.445)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(5.022 11.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M445.074,434.535c-.077.045-.041.24.078.436s.28.321.357.278.041-.238-.078-.436S445.15,434.491,445.074,434.535Z",
    transform: "translate(-445.033 -434.526)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(5.489 7.895)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M432.138,434.1l21.1,15.577,1.952-2.451L433.016,432.7Z",
    transform: "translate(-432.138 -432.696)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(126.971 370.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(0.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M397.034,455.716l-.039-13.708-26.576-.095-.162,20.058,1.646.107c7.333.419,37.311,1.634,42.218.215C419.6,460.709,397.034,455.716,397.034,455.716Z",
    transform: "translate(-370.256 -441.913)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(0.373 16.623)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M408.012,451.557s7.906,2.234,6.914,3.49-31.336,1.131-44.714-.055l.045-.574,35.392.436S406.463,451.614,408.012,451.557Z",
    transform: "translate(-370.212 -451.557)",
    fill: "#ad5fb5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    transform: "translate(0 19.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M370.254,453.213a2.606,2.606,0,0,0,.457.05l1.311.081,4.83.221c4.078.159,9.716.305,15.947.336s11.871-.062,15.952-.181l4.831-.174,1.313-.069a2.591,2.591,0,0,0,.457-.045,2.356,2.356,0,0,0-.458-.019l-1.315.012-4.832.074c-4.081.064-9.718.121-15.945.091s-11.862-.143-15.942-.246c-1.905-.047-3.519-.088-4.832-.121l-1.315-.024A2.349,2.349,0,0,0,370.254,453.213Z",
    transform: "translate(-370.254 -453.199)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(35.755 16.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M374.071,455.386a10.288,10.288,0,0,1,.912-2.224,10.623,10.623,0,0,1,1.655-1.78A3.547,3.547,0,0,0,374.71,453,3.355,3.355,0,0,0,374.071,455.386Z",
    transform: "translate(-374.026 -451.374)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(27.962 14.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M379.066,452.35c.075.047.453-.393.844-.982s.646-1.1.571-1.15-.453.393-.844.982S378.991,452.3,379.066,452.35Z",
    transform: "translate(-379.053 -450.214)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(25.822 13.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M380.126,451.415c.059.064.48-.205.938-.6s.785-.769.726-.833-.48.2-.94.6S380.067,451.352,380.126,451.415Z",
    transform: "translate(-380.119 -449.973)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(24.479 12.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M380.256,449.457a6.259,6.259,0,0,0,2.777.043,3.231,3.231,0,0,0-1.386-.178A3.289,3.289,0,0,0,380.256,449.457Z",
    transform: "translate(-380.256 -449.321)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874",
    transform: "translate(24.018 11.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M380.309,448.419a4.027,4.027,0,0,0,3.145.241,8.982,8.982,0,0,0-1.573-.11A8.654,8.654,0,0,0,380.309,448.419Z",
    transform: "translate(-380.308 -448.393)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(28.886 11.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M376.53,451.118a5.031,5.031,0,0,0,1.709,0,10.231,10.231,0,0,0,1.819-.379,5.029,5.029,0,0,0,1.042-.41.9.9,0,0,0,.426-.51.64.64,0,0,0-.257-.662,3.2,3.2,0,0,0-3.876.87,2.891,2.891,0,0,0-.562,1.1c-.07.283-.066.443-.046.446a4.594,4.594,0,0,1,.783-1.4,3.1,3.1,0,0,1,1.465-.91,2.721,2.721,0,0,1,2.033.143c.271.195.164.5-.139.674a5.248,5.248,0,0,1-.961.393,11.956,11.956,0,0,1-1.761.434C377.181,451.07,376.53,451.069,376.53,451.118Z",
    transform: "translate(-376.53 -448.824)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(27.111 11.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M381.191,451.548a1.58,1.58,0,0,0,.2-1.145,2.649,2.649,0,0,0-.46-1.208,1.717,1.717,0,0,0-1.418-.846.655.655,0,0,0-.53.758,1.758,1.758,0,0,0,.287.739,4.988,4.988,0,0,0,.8,1,2.453,2.453,0,0,0,.976.672c.029-.04-.339-.3-.808-.822a5.736,5.736,0,0,1-.71-.993c-.234-.35-.391-.977.037-1.05.428-.038.862.374,1.122.705a2.684,2.684,0,0,1,.478,1.074A5.944,5.944,0,0,1,381.191,451.548Z",
    transform: "translate(-378.973 -448.347)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(0.573 12.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M389.936,449.2c.007.059.762-.065,1.962.076A8.755,8.755,0,0,1,396.176,451a8.285,8.285,0,0,1,2.66,3.666c.4,1.1.437,1.843.5,1.836a1.435,1.435,0,0,0,0-.519,6.657,6.657,0,0,0-.284-1.386,7.928,7.928,0,0,0-2.676-3.84,8.388,8.388,0,0,0-4.456-1.7,7.219,7.219,0,0,0-1.461.029A1.684,1.684,0,0,0,389.936,449.2Z",
    transform: "translate(-389.936 -449.035)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(3.096 1.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M393.87,442.938a86.789,86.789,0,0,0-.185,10.552,86.755,86.755,0,0,0,.185-10.552Z",
    transform: "translate(-393.592 -442.938)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(13.364 17.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M383.69,452.02a22.6,22.6,0,0,0,7.767.1c-.009-.091-1.745.005-3.883-.028S383.7,451.931,383.69,452.02Z",
    transform: "translate(-383.69 -451.991)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(8.143 17.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M390.553,452c-.064.062.141.357.316.741s.271.727.362.722.139-.405-.068-.85S390.61,451.933,390.553,452Z",
    transform: "translate(-390.541 -451.985)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(6.189 14.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M391.508,450.622c-.062.06.107.328.382.6s.548.441.61.381-.107-.328-.38-.6S391.573,450.562,391.508,450.622Z",
    transform: "translate(-391.495 -450.61)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(3.399 13.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M392.783,450.045c.018.088.371.086.76.221s.671.336.74.279-.15-.414-.635-.574S392.756,449.965,392.783,450.045Z",
    transform: "translate(-392.782 -449.9)",
    fill: "#ad5fb5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(1.398 13.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M394.3,449.708c-.032.081.12.214.339.3s.426.086.458.007-.119-.212-.341-.3S394.337,449.629,394.3,449.708Z",
    transform: "translate(-394.301 -449.651)",
    fill: "#ad5fb5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(0.372 8.175)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M380.308,449.891l26.791.026-.028-3.092-26.666-.169Z",
    transform: "translate(-380.308 -446.656)",
    fill: "#ad5fb5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(88.519 136.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M366.977,317.4l10.642,30.966c2.874,8.363,10.435,9.794,19.554,9.794h59.2V345.33l-54.082-7.462L389.4,306.053Z",
    transform: "translate(-366.977 -306.053)",
    fill: "#b78876"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(89.394 25.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M353.253,332.01l4.7-2.148s5.061-9.456,6.225-9.077,1.5,3.161-.532,7.5l6.241-1.722s13.528,6.04,12.929,6.853-1.705,2.741-4.652,1.284-6.807-3.165-6.807-3.165l-7.29,2.011,9.4,1.153,8.839,7.772s-2.9,2.1-5.407-.129l-22.959,4.768-7.192.393V334.677Z",
    transform: "translate(-346.746 -320.775)",
    fill: "#b78876"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(17.759 17.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M362.46,335.2c-.1.062-.524-.593-1.35-1.465a5.929,5.929,0,0,0-4.151-1.874c-3.826-.438-6.916-.946-6.891-1.136s3.143.007,6.978.446a6.938,6.938,0,0,1,2.724.762,6.345,6.345,0,0,1,1.725,1.482C362.276,334.433,362.529,335.161,362.46,335.2Z",
    transform: "translate(-350.068 -330.653)",
    fill: "#aa6550"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(18.931 20.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M359.668,334.522c-.087,0-.159-.459-.8-.591-.656-.115-1.7-.236-2.79-.345-2.2-.215-4.019-.2-4.037-.4-.023-.183,1.821-.517,4.106-.295a12.753,12.753,0,0,1,2.89.572,1.131,1.131,0,0,1,.7.7C359.793,334.4,359.711,334.529,359.668,334.522Z",
    transform: "translate(-352.039 -332.821)",
    fill: "#aa6550"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(0 77.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M484.658,335.071l4.552,14.9,28.894-12.64c-1.038-3.12-5.817-17.019-14.966-39.072a38.983,38.983,0,0,0-29.95-23.328c-9.456-1.52-19.743-2.706-27.665-2.622-16.2.172-40.055,9.959-43.258,25.307-2.447,11.714-.087,32.4-.087,57.527l2.114,48.016,83.028,2.722Z",
    transform: "translate(-401.154 -272.309)",
    fill: "#ad5fb5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(1.111 70.835)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M431.587,314.295c10.1,2,20.476-.016,30.77-.607,6.243-.357,13.166-1.01,18.1,2.7,3.915,2.941,5.49,7.882,6.621,12.546,4.306,17.78,5.089,29.7,6.058,47.937L443.162,379.8Z",
    transform: "translate(-431.587 -313.404)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(75.043 10.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M429.3,278.492c.011.072-.831.119-2.208.641a11.471,11.471,0,0,0-4.782,3.742,15.234,15.234,0,0,0-2.858,8.358,50.872,50.872,0,0,0,.874,11,178.933,178.933,0,0,0,4.64,19.667c.683,2.408,1.249,4.4,1.678,5.907a13.54,13.54,0,0,1,.532,2.192,13.817,13.817,0,0,1-.8-2.115c-.467-1.374-1.126-3.37-1.9-5.85a148.443,148.443,0,0,1-4.861-19.693,49.039,49.039,0,0,1-.824-11.152,15.451,15.451,0,0,1,3.111-8.61,11.288,11.288,0,0,1,5.091-3.7,8.335,8.335,0,0,1,1.7-.374A2.02,2.02,0,0,1,429.3,278.492Z",
    transform: "translate(-418.71 -278.478)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(86.903 61.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M430.8,307.83a27.969,27.969,0,0,1-4.071,2.256c-2.567,1.3-6.158,3.01-10.187,4.766s-7.734,3.225-10.44,4.223a28.623,28.623,0,0,1-4.445,1.455,33.625,33.625,0,0,1,4.253-1.91c2.652-1.112,6.316-2.649,10.339-4.4s7.636-3.389,10.257-4.573A33.734,33.734,0,0,1,430.8,307.83Z",
    transform: "translate(-401.659 -307.823)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(35.761 209.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(0 5.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M479.114,351.922c14.145,7.457,19.518,24.479,12.083,38.295L418.932,510.107l-33.341-19.458L441.707,382.4l-40.67-25.653",
    transform: "translate(-385.591 -351.922)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(5.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M371.951,348.472l99.2,3.394c16.1.552,28.792,13.451,28.54,29.021L495.574,517.8l-41.721-.09,1.391-129.447-83.293-2.117Z",
    transform: "translate(-371.951 -348.472)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(81.822 44.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M398.3,374.271a6.758,6.758,0,0,0-.119,1.265c-.039.919-.095,2.125-.161,3.633-.125,3.156-.251,7.724-.373,13.367-.25,11.29-.417,26.887-.507,44.112-.091,17.187-.173,32.739-.234,44.115-.032,5.571-.059,10.113-.078,13.369.005,1.508.011,2.716.013,3.637a6.621,6.621,0,0,0,.068,1.269,6.465,6.465,0,0,0,.119-1.265c.041-.919.095-2.125.162-3.633.125-3.154.252-7.722.373-13.367.25-11.288.417-26.887.507-44.119.091-17.18.173-32.732.234-44.108.032-5.569.059-10.113.077-13.369,0-1.508-.009-2.718-.012-3.637A6.419,6.419,0,0,0,398.3,374.271Z",
    transform: "translate(-396.826 -374.271)",
    fill: "#455a64"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(56.864 122.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M418.335,298.066h30.012c12.082,0,21.876,9.463,21.876,21.137v101.18h59.962a14.9,14.9,0,0,1,15.15,14.637H408.425c0-.028,0-.055,0-.083a12.268,12.268,0,0,1-11.966-12.057V319.2C396.461,307.529,406.254,298.066,418.335,298.066Z",
    transform: "translate(-396.461 -298.066)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(64.573 3.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M443.664,300c-.255,0-.464,29.735-.464,66.406s.209,66.413.464,66.413.466-29.728.466-66.413S443.921,300,443.664,300Z",
    transform: "translate(-443.2 -300.002)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(28.622 137.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M455.318,483.7V377.556h9.757V483.7c5.956,11.347,19.96,19.024,37.021,25.31H415.11C432.777,502.075,448.72,496.75,455.318,483.7Z",
    transform: "translate(-415.11 -377.556)",
    fill: "#455a64"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatstableguy);
export default __webpack_public_path__ + "static/media/Statstableguy.f07d2001969d0c379d2aa845344248dd.svg";
export { ForwardRef as ReactComponent };